import {createContext} from 'react'
import {type Dimensions} from './types/dimensions'
import {DEFAULT_DIMENSIONS_DATA} from './types/default-dimensions-data'

export const DimensionsContext = createContext<Dimensions>(DEFAULT_DIMENSIONS_DATA)
